import Request from "./request";
import consts from "@/consts.js";

// 车次管理
async function fetch(data) {
  return Request("get", "api/stock-trucks", data);
}

async function fetchAllForSelect(data) {
  if (!data) data = {};
  data.limit = consts.limitAll; //获取全部
  return Request("get", "api/stock-trucks/select", data);
}

// 删除数据
async function del(id) {
  return Request("delete", "api/stock-trucks/delete/" + id);
}

// 编辑或新建（有id为编辑，没有id为新建）
async function save(id, data) {
  if (id) {
    return Request("post", "api/stock-trucks/edit?id=" + id, data);
  } else {
    return Request("post", "api/stock-trucks/add", data);
  }
}

export default {
  fetch,
  fetchAllForSelect,
  del,
  save,
};
